import React from "react";
import { useSelector } from "react-redux";
import wavingHand from "../../../utilities/images/study_dashboard/waving_hand.svg";
import DashboardChangeCourseButton from "./DashboardChangeCourseButton";
import "./DashboardUserProfile.css";

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "Good Morning";
  if (hour < 17) return "Good Afternoon";
  return "Good Evening";
};

const DashboardUserProfile = () => {
  const userPreference = useSelector((state) => state.userPreference);
  const userData = useSelector((state) => state.auth.user);

  const firstName = String(userData?.name || "Student").trim().split(/\s+/)[0];
  const selectedStream =
    userPreference?.targetDetails?.[0]?.target ||
    userPreference?.courseDetails?.[0]?.target ||
    "";
  const selectedClass = userPreference?.classDetails?.class || "";

  return (
    <section className="dashboard-user-profile" aria-label="User profile">
      <div className="dashboard-user-profile__content">
        <div className="dashboard-user-profile__greeting-row">
          <h1 className="dashboard-user-profile__greeting">
            {getGreeting()}, {firstName}
          </h1>
          <span className="dashboard-user-profile__wave-wrap" aria-hidden="true">
            <img
              src={wavingHand}
              alt=""
              className="dashboard-user-profile__wave"
              width={32}
              height={32}
            />
          </span>
        </div>

        <div className="dashboard-user-profile__meta-row">
          <div className="dashboard-user-profile__chips">
            {selectedStream ? (
              <span className="dashboard-user-profile__chip">{selectedStream}</span>
            ) : null}
            {selectedClass ? (
              <span className="dashboard-user-profile__chip">{selectedClass}</span>
            ) : null}
          </div>

          <DashboardChangeCourseButton />
        </div>
      </div>
    </section>
  );
};

export default DashboardUserProfile;
